import { render, staticRenderFns } from "./TheInfoModal.vue?vue&type=template&id=28a5c88b&scoped=true&"
import script from "./TheInfoModal.vue?vue&type=script&lang=js&"
export * from "./TheInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a5c88b",
  null
  
)

export default component.exports